import { NavigationGuardNext, Route } from 'vue-router';
import { BootstrapStore } from '@front-app/store/singletons/Bootstrap';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { PhoenixMeta } from '../Model';

/**
 * A guard function to handle cases where the user is NOT logged in, but should be
 */
export async function loginGuard(to: Route, from: Route, next: NavigationGuardNext): Promise<void> {
	await BootstrapStore.getInstance().bootstrap();

	// eslint-disable-next-line prefer-destructuring
	const meta: undefined | PhoenixMeta = to.meta;

	// For public routes, and logged in user, we always allow the user to visit them
	if (meta?.isPublic || CurrentUserStore.isLoggedIn.value) {
		next();
		return;
	}

	// Store the path to redirect to in case the user is not registered and will need to be redirected after registration
	const redirectURL = localStorage.getItem('redirect_url');
	if (!redirectURL) {
		localStorage.setItem('redirect_url', to.fullPath);
	}

	// Redirect to login route if it is set on the current route or any ancestor route
	const routeWithLoginPage = [...to.matched].reverse().find((candidateRoute) => candidateRoute.meta?.loginRoute);
	if (routeWithLoginPage) {
		const resolvedRoute = routeWithLoginPage.meta.loginRoute(to);
		resolvedRoute.query = resolvedRoute.query || {};
		// Save the current path so we can redirect back to it after login
		// This should be handled on the login page itself
		resolvedRoute.query.url = to.fullPath;
		next(resolvedRoute);
	} else {
		// Otherwise, fall back to the standard logout page.
		const url = `${process.env.VUE_APP_TRAPP_PUBLIC_URL}${process.env.VUE_APP_PUBLIC_PATH}${to.fullPath}`;
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		window.location.assign(`/app/logout.shtml?url=${encodeURIComponent(url)}`);
	}
}
